const HEADERS = ['Código', 'Cantidad', 'Autos', 'Fechas', 'Zona', 'Encargado', 'WhatsApp', 'Grupos de predicación']

const normalizeHeader = (s) =>
  String(s || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')

const ALIASES = {
  codigo: ['codigo'],
  cantidad: ['cantidad'],
  autos: ['autos'],
  fechas: ['fechas'],
  zona: ['zona'],
  encargado: ['encargado'],
  whatsapp: ['whatsapp'],
  grupos: ['grupos de predicacion', 'grupos'],
}

// Excel en configuración regional en español (ej. Argentina) exporta CSV usando ";"
// como separador de columnas en lugar de ",". Detectamos cuál se usó mirando la
// primera línea del archivo (fuera de comillas).
export function detectDelimiter(text) {
  const firstLine = text.split(/\r?\n/)[0] || ''
  let commas = 0
  let semicolons = 0
  let inQuotes = false
  for (const char of firstLine) {
    if (char === '"') inQuotes = !inQuotes
    else if (!inQuotes && char === ',') commas += 1
    else if (!inQuotes && char === ';') semicolons += 1
  }
  return semicolons > commas ? ';' : ','
}

// Tokenizer RFC4180: soporta comillas, el delimitador indicado y saltos de línea embebidos en un campo.
export function parseCsv(text, delimiter = ',') {
  const rows = []
  let row = []
  let field = ''
  let inQuotes = false
  let i = 0

  while (i < text.length) {
    const char = text[i]
    if (inQuotes) {
      if (char === '"') {
        if (text[i + 1] === '"') {
          field += '"'
          i += 2
          continue
        }
        inQuotes = false
        i += 1
        continue
      }
      field += char
      i += 1
      continue
    }

    if (char === '"') {
      inQuotes = true
      i += 1
      continue
    }
    if (char === delimiter) {
      row.push(field)
      field = ''
      i += 1
      continue
    }
    if (char === '\r' || char === '\n') {
      row.push(field)
      rows.push(row)
      field = ''
      row = []
      if (char === '\r' && text[i + 1] === '\n') i += 1
      i += 1
      continue
    }
    field += char
    i += 1
  }

  if (field !== '' || row.length) {
    row.push(field)
    rows.push(row)
  }

  return rows.filter((r) => r.some((cell) => String(cell).trim() !== ''))
}

const toCsvField = (value) => {
  const str = String(value ?? '')
  if (/[",\n\r]/.test(str)) return `"${str.replace(/"/g, '""')}"`
  return str
}

export function buildGuestGroupsTemplateCsv(gruposPredicacion, zonas) {
  const nombresEjemplo = (gruposPredicacion || []).slice(0, 2).map((g) => g.name)
  const grupoEjemplo = nombresEjemplo.length ? nombresEjemplo.join(';') : 'Grupo 1;Grupo 2'
  const zonaEjemplo = (zonas || [])[0]?.name || 'Zona Norte'
  const ejemplo = ['INV-01', '4', '1', '2026-08-15', zonaEjemplo, 'Pérez, Juan', '+54 9 11 5555-5555', grupoEjemplo]

  const lines = [HEADERS, ejemplo].map((row) => row.map(toCsvField).join(','))
  return '﻿' + lines.join('\r\n') + '\r\n'
}

export function parseGuestGroupsCsv(text, gruposPredicacion, zonas) {
  const clean = text.charCodeAt(0) === 0xfeff ? text.slice(1) : text
  const delimiter = detectDelimiter(clean)
  // Si el delimitador de columnas es ";", la coma queda libre para separar
  // varios grupos de predicación dentro de una misma celda (y viceversa).
  const groupSeparator = delimiter === ';' ? ',' : ';'
  const table = parseCsv(clean, delimiter)
  if (!table.length) return { rows: [], unresolvedGroups: [], unresolvedZonas: [] }

  const headerIndex = {}
  table[0].forEach((cell, idx) => {
    const normalized = normalizeHeader(cell)
    const key = Object.keys(ALIASES).find((k) => ALIASES[k].includes(normalized))
    if (key) headerIndex[key] = idx
  })

  const rows = []
  const unresolvedGroups = []
  const unresolvedZonas = []

  for (let i = 1; i < table.length; i++) {
    const line = i + 1
    const cells = table[i]
    if (cells.every((c) => String(c).trim() === '')) continue

    const get = (key) => (headerIndex[key] != null ? String(cells[headerIndex[key]] ?? '').trim() : '')

    const nombresGrupos = get('grupos')
      .split(groupSeparator)
      .map((n) => n.trim())
      .filter(Boolean)

    const grupos = nombresGrupos.map((nombre) => {
      const match = (gruposPredicacion || []).find(
        (g) => String(g.name).trim().toLowerCase() === nombre.toLowerCase()
      )
      if (!match) {
        unresolvedGroups.push({ line, nombre })
        return nombre
      }
      return match.id
    })

    const nombreZona = get('zona')
    let zonaId = null
    if (nombreZona) {
      const match = (zonas || []).find((z) => String(z.name).trim().toLowerCase() === nombreZona.toLowerCase())
      if (match) zonaId = match.id
      else unresolvedZonas.push({ line, nombre: nombreZona })
    }

    rows.push({
      line,
      codigo: get('codigo'),
      cantidad: get('cantidad'),
      autos: get('autos'),
      fechas: get('fechas'),
      zonaId,
      encargado: get('encargado'),
      whatsapp: get('whatsapp'),
      grupos,
    })
  }

  return { rows, unresolvedGroups, unresolvedZonas }
}
